
import Button from '@/components/Button.vue';
import {
  defineComponent,
  computed,
  ref,
  onMounted, onBeforeUnmount,
} from 'vue';
import {
  useStore,
} from 'vuex';
import Equalize from '@/utils/Equalize';
import TextSectionHeadline from '@/components/text_section/TextSectionHeadline.vue';
import EventInterface from '@/interfaces/EventInterface';

export default defineComponent({
  components: {
    Button,
    TextSectionHeadline,
  },
  props: {
    paddingTop: {
      type: String,
      required: false,
      default: () => 'default',
    },
    paddingBottom: {
      type: String,
      required: false,
      default: () => 'default',
    },
    spacer: {
      type: String,
      required: false,
      default: () => 'none',
    },
    spacerCloudsPlacement: {
      type: String,
      required: false,
      default: () => 'bottom',
    },
    spacerBarAlign: {
      type: String,
      required: false,
      default: () => 'right',
    },
  },

  setup(props) {
    const store = useStore();

    const events = computed(() => store.getters['events/current']);
    const pastEvents = computed(() => store.getters['events/past']);
    const root = ref();

    const containerClasses = computed<string[]>(() => {
      const containerClassesComputed: string[] = [];

      if (props.paddingTop === 'none') {
        containerClassesComputed.push('pt-0');
      }

      if (props.paddingBottom === 'none') {
        containerClassesComputed.push('pb-0');
      }

      return containerClassesComputed;
    });

    const dateFormated = ($date: string) => $date.split('-').reverse().join('.');

    const equalizeCards = () => {
      if (root.value) {
        console.log('run equalize');
        console.log(root.value);
        Equalize.run(root.value);
      }
    };

    onMounted(() => {
      window.addEventListener('resize', equalizeCards);
      window.addEventListener('load', equalizeCards);
      equalizeCards();
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', equalizeCards);
      window.removeEventListener('load', equalizeCards);
    });

    const hasLocation = ($event: EventInterface) => (($event.location || '')
            + ($event.location || '')
            + ($event.street || '')
            + ($event.city || '')) !== '';

    return {
      events,
      pastEvents,
      containerClasses,
      dateFormated,
      root,
      hasLocation,
    };
  },
});
